import { useState, useCallback } from "react";
import axiosVortex from "../../../utils/axios.instance";
import type {
  OrderDataFormerProbs,
  OrderPlacementPayload,
} from "../../../models/orders";

import BrokerApi from "../../../chart-brokerapi/broker";
import { getFinalVariety } from "../../../utils/orders.helper";

interface UseOrderRequestResponse {
  data: any; // Replace with a specific type for the response data
  loading: boolean;
  error: string | null;
  mutate: (
    payload: any,
    options?: {
      onSuccess?: (data: any) => void;
      onError?: (error: string) => void;
    }
  ) => Promise<void>;
}

const updateOrders = (): UseOrderRequestResponse => {
  const [data, setData] = useState<any>(null); // Replace with a specific type for the response data
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const mutate = useCallback(
    async (
      payload: any,
      options?: {
        onSuccess?: (data: any) => void;
        onError?: (error: string) => void;
      }
    ) => {
      setLoading(true);
      setError(null);
      setData(null);

      var orderPlacement: OrderPlacementPayload = BrokerApi.instance
        ?._orderById[String(payload.order_id)] as OrderPlacementPayload;
        
      const modufiedPayload = {
        variety: getFinalVariety(payload.isStopLoss, payload.orderType === "Market"),
        quantity: payload.market_segment_id === 5 ? +payload.lots : +payload.lots * +payload.odin_lot_size,
        price: payload.orderType === "Market" ? 0 : +payload.price,
        trigger_price: payload.isStopLoss ? +payload.triggerPrice : null,
        validity: payload.validity,
        disclosed_quantity: payload.disclosed_quantity,
        traded_quantity: Number(
          orderPlacement.traded_quantity == null
            ? 0
            : payload.odin_exchange === "MCX_FO" 
            ? orderPlacement.traded_quantity
            : Number(orderPlacement.traded_quantity) *
              Number(payload.odin_lot_size)
        ), 
        order_id: payload.order_id, 
        market_segment_id: payload.market_segment_id, 
      };

      try {
        const encodedParam = encodeURIComponent(String(payload.order_id));
        const partialFinalURL = `trading/orders/regular/${encodedParam}`
        const response = await axiosVortex.put(partialFinalURL, modufiedPayload);

        if (response.data.status === "success") {
          setData(response.data); // Set response data on success
          options?.onSuccess?.(response.data); // Call the onSuccess callback
        } else {
          throw new Error(response.data.message || "Order request failed");
        }
      } catch (err: any) {
        const errorMessage = err.response?.data?.message || err.message || "Unknown error occurred";
        // Handle 500 status code specifically
        if (err.response.data.status === 'error') {
          BrokerApi.instance?._host.showNotification(
            "Order placement",
            err.response.data.message,
            0
          );
        }
        setError(errorMessage); // Set error message
        options?.onError?.(errorMessage); // Call the onError callback
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { data, loading, error, mutate };
};

export default updateOrders;
